import React, { useState } from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ClassTabs = ({ readMore }) => {
  // State to keep track of the active tab
  const [activeTab, setActiveTab] = useState(0);

  const navigate = useNavigate();
  // Array of tab data including images and content
  const tabData = [
    {
      image:
        "https://webapi.entab.info/api/image/STPSFH/public/Images/early.png",
      title: (
        <>
          Early Years <br /> (Nursery–KG)
        </>
      ),
      content: `At St. Peter’s Convent School, the Foundational Stage focuses on holistic early childhood development in alignment with NEP 2020. 
This stage covers Nursery, LKG, UKG catering to children aged 3–5 years. 
Learning is play-based, joyful, and experiential, helping children develop cognitive, emotional, physical, and social skills. 
Students engage in storytelling, creative arts, music, movement, and sensory activities, fostering curiosity, imagination, and self-expression.`,
      readMore: "/Courses#early-years-section",
    },
    {
      image:
        "https://webapi.entab.info/api/image/STPSFH/public/Images/prepatory.png", // Use the imported image
      title: (
        <>
          Preparatory <br />
          (Classes I–V)
        </>
      ),
      content:
        "The Preparatory Stage builds on the foundational years, guiding students through Grades 1 to 5, where they start developing conceptual understanding and academic skills. Subjects include languages, mathematics, environmental science, and social studies, taught through experiential, hands-on learning and real-world applications.",
      readMore: "/courses#preparatory ",
    },
    {
      image:
        "https://webapi.entab.info/api/image/STPSFH/public/Images/middle.png", // Use the imported image
      title: (
        <>
          Middle School
          <br /> (Classes VI–VIII)
        </>
      ),
      content:
        " The Middle Stage at SPCS covers Grades 6 to 8 and emphasizes inquiry-based and interdisciplinary learning. Students engage in science, mathematics, languages, social studies, and arts, integrating practical experiments, projects, and real-life applications to strengthen understanding.",
      readMore: "/courses#middle",
    },
    {
      image:
        "https://webapi.entab.info/api/image/STPSFH/public/Images/secondary.png", // Use the imported image
      title: (
        <>
          Secondary Stage <br />
          (Grades 9–10)
        </>
      ),
      content:
        " The Secondary Stage includes Grades 9 and 10 and focuses on conceptual clarity, skill development, and holistic growth. Core subjects such as languages, mathematics, science, and social studies are taught through experiential projects, laboratory work, and inquiry-based learning.",
      readMore: "/courses#secondary",
    },
    {
      image:
        "https://webapi.entab.info/api/image/STPSFH/public/Images/senior-secondary.png", // Use the imported image
      title: (
        <>
          Senior Secondary Stage <br />
          (Grades 11–12)
        </>
      ),
      content:
        " In alignment with NEP 2020, the Senior Secondary Stage emphasizes stream-based specialization with multidisciplinary flexibility. Students choose from Medical, Non-Medical, and Commerce streams, with opportunities to take additional subjects to explore interests and enhance skills.",
      readMore: "/courses#senior",
    },
  ];

  const handleReadMore = () => {
    const url = tabData[activeTab].readMore;
    navigate(url);
  };

  return (
    <div className="class-tabs">
      <div className="tabs">
        {tabData.map((tab, index) => (
          <div
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            <div className="tabs-img">
              <LazyLoad>
                <img src={tab.image} alt={tab.title} className="tab-image" />
              </LazyLoad>
            </div>
            <div className="tab-title">{tab.title}</div>
          </div>
        ))}
      </div>
      <div className="tabs-content">
        <div className="content">
          <p>{tabData[activeTab].content}</p>
          <button className="button">
            {" "}
            <Link to={tabData[activeTab].readMore}>
              {" "}
              Read More <i className="bi bi-arrow-right"></i>{" "}
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClassTabs;
